<template>
  <div ref="q_a" id="q-a"> 
    <vs-tabs v-model="activeTab">
        <vs-tab label="Ask a Question">
          <vs-divider><i style="width:50px" class="icon feather icon-help-circle text-white"></i></vs-divider>
          <div class="vx-col w-full">
            <label for="question">Question</label>
            <vs-textarea style="color:black;" id="question" class="mt-1" v-model="studentQuestion"/>
            <vs-button color="success" @click="postQuestion">Submit Question</vs-button>
          </div>
        </vs-tab>

        <vs-tab ref="task_questions" label="View your questions">
          <vs-divider><i style="width:50px" class="icon feather icon-help-circle text-white"></i></vs-divider>
          <div v-if="taskQuestions.length">
            <vs-table
              stripe
              ref="publicquestionTable"
              class="vs-con-loading__container"
              single
              pagination
              max-items="10"
              :data="taskQuestions"
            >
              <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <h3>Public Questions and Answers</h3>
              </div>
              <template slot="thead">
                <vs-th sort-key="question">Question</vs-th>
                <vs-th sort-key="answer">Answer</vs-th>
                <vs-th sort-key="dateAsked">Date Asked</vs-th>
                <vs-th sort-key="dateAnswered">Date Answered</vs-th>
                <vs-th sort-key="teacherName">By Teacher</vs-th>

              </template>

              <template slot-scope="{ data }">
                
                <vs-tr
                  :data="question"
                  :key="indextr"
                  v-for="(question, indextr) in data"
                >
                  <vs-td :data="data[indextr].question">
                    {{ question.question }}
                  </vs-td>

                  <vs-td :data="data[indextr].answer">
                    {{ question.answer }}
                  </vs-td>

                  <vs-td :data="data[indextr].dateAsked">
                    {{ question.dateAsked }}
                  </vs-td>

                  <vs-td :data="data[indextr].dateAnswered">
                    {{ question.dateAnswered }}
                  </vs-td>

                  <vs-td :data="data[indextr].teacherName">
                    {{ question.teacherName }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div v-else>
            <h4>No questions to display.</h4>
          </div>
        </vs-tab>

        <vs-tab ref="public_questions" label="Public Questions">
          <vs-divider><i style="width:50px" class="icon feather icon-help-circle text-white"></i></vs-divider>
          <div v-if="publicQuestions.length">
            <vs-table
              stripe
              ref="publicquestionTable"
              class="vs-con-loading__container"
              single
              pagination
              max-items="10"
              :data="publicQuestions"
            >
              <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <h3>Public Questions and Answers</h3>
              </div>
              <template slot="thead">
                <vs-th sort-key="question">Question</vs-th>
                <vs-th sort-key="answer">Answer</vs-th>
                <vs-th sort-key="dateAsked">Date Asked</vs-th>
                <vs-th sort-key="dateAnswered">Date Answered</vs-th>
                <vs-th sort-key="teacherName">By Teacher</vs-th>

              </template>

              <template slot-scope="{ data }">
                
                <vs-tr
                  :data="question"
                  :key="indextr"
                  v-for="(question, indextr) in data"
                >
                  <vs-td :data="data[indextr].question">
                    {{ question.question }}
                  </vs-td>

                  <vs-td :data="data[indextr].answer">
                    {{ question.answer }}
                  </vs-td>

                  <vs-td :data="data[indextr].dateAsked">
                    {{ question.dateAsked }}
                  </vs-td>

                  <vs-td :data="data[indextr].dateAnswered">
                    {{ question.dateAnswered }}
                  </vs-td>

                  <vs-td :data="data[indextr].teacherName">
                    {{ question.teacherName }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div v-else>
            <h4>No public questions to display.</h4>
          </div>
        </vs-tab>
      </vs-tabs>
  </div>
</template> 

<script>
export default {
  data() {
    return { 
      activeTab:0,
      publicQuestions:[],
      taskQuestions:[],
      studentQuestion:"",
    }
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
  },
  components:{ 

  },
  watch:{ 
    isActive: function(){
      var self = this;
      if(self.isActive)
      {
        self.getQAForTask();
      }
    },
  },
  computed: { 

  },
  methods: { 
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    postQuestion(){
      var self = this;
      const params = new URLSearchParams(window.location.search);
      if(!params.has('id')){
        return
      }
      self.showLoadingOnElement("q_a",1,"corners");

      var sendData = {
        TaskId:params.get('id'),
        Question:self.studentQuestion
      }

      var onSuccess = response =>{
        self.getQAForTask();
        self.activeTab = 1;
        self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Question Submitted",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-check'
            });
      }
    
      var onFinally = response =>{
        if(self.$refs.q_a){
          self.$vs.loading.close(self.$refs.q_a.$el);
        }
      }
    
      self.$ajaxPost(self, "student/TaskQA/submitQuestion" , sendData , onSuccess, onFinally);
    },
    getQAForTask(){
      var self = this;
      const params = new URLSearchParams(window.location.search);
      self.showLoadingOnElement("q_a",1,"corners");


      var onSuccess = response =>{
        self.publicQuestions = response.data.taskPublicQuestions;
        self.taskQuestions = response.data.userQuestions;
      }
    
      var onFinally = response =>{
        if(self.$refs.q_a){
          self.$vs.loading.close(self.$refs.q_a.$el);
        }
      }
    
      self.$ajaxGet(self, `TaskQA/QuestionsForTask/${params.get('id')}` , onSuccess, onFinally);
    },
  }
}
</script>


<style lang="scss"> 
#q-a{
  .vs-textarea{
  background: white;
  color: black;
}
.vs-popup{
  width: 70vw !important;
  height: 70vh;
}

.vs-textarea{
    background: white !important;
    color: black !important;
  }
}
</style>
